import React from 'react';
import usePageTranslation from '../../../../shared/hooks/usePageTranslation';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ page, totalPages, onPageChange }) => {
  const { t } = usePageTranslation('panel', 'UserRolesManagement');

  if (totalPages <= 1) return null;

  return (
    <div className="mt-6 flex items-center justify-between">
      <button
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="px-4 py-2 bg-gray-700/50 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-700 transition-colors"
      >
        {t('pagination.previous')}
      </button>
      <span className="text-gray-400">
        {t('pagination.page')} {page} / {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="px-4 py-2 bg-gray-700/50 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-700 transition-colors"
      >
        {t('pagination.next')}
      </button>
    </div>
  );
};

export default Pagination;

